/** @jsx jsx */
import React, { CSSProperties } from 'react'
import { css, jsx } from '@emotion/react'

type HorizonProps = {
  children: React.ReactNode
  columnGap?: string
  display?: string
  justifyContent?: string
  alignItems?: string
  style?: CSSProperties
  columnGaps?: string[] | number[]
  as?: React.ElementType<any>
  onClick?: (e: any) => void
}
export const Horizon = ({
  children,
  columnGap,
  display = 'grid',
  justifyContent = 'left',
  alignItems = 'center',
  style,
  columnGaps,
  as: Component = 'div',
  ...props
}: HorizonProps) => {
  let gapCss = ``
  if (columnGaps) {
    columnGaps.forEach((gap, i) => {
      if (typeof gap === 'string') {
        gapCss += `
  & > *:nth-child(${i + 2}) {
    margin-left: ${gap};
  }
      `
        return
      }
      gapCss += `
  & > *:nth-child(${i + 2}) {
    margin-left: ${gap}px;
  }
      `
    })
  }
  const horizonStyle = css`
    display: ${display};
    grid-auto-flow: column;
    column-gap: ${columnGap};
    justify-content: ${justifyContent};
    align-items: ${alignItems};
    ${gapCss}
  `
  return (
    <Component css={horizonStyle} style={style} {...props}>
      {children}
    </Component>
  )
}
